/* eslint-disable consistent-return */
import { useEffect } from 'react'

import { useRokt } from './context'

const RoktPlaceholder = props => {
  const { attributes, page } = props

  const rokt = useRokt()

  useEffect(() => {
    if (!attributes || !page) {
      return
    }

    if (!rokt) {
      console.error('Rokt not found')
      return
    }

    rokt.setAttributes(attributes)
    rokt.triggerPageChange(page)

    return () => {
      rokt.closeAll()
    }
  }, [rokt])

  return <div id="rokt-placeholder" />
}

export default RoktPlaceholder
